import {Component} from "@angular/core";
import {Page} from "../../../orchestration/page";
import {NavigationService} from "../../../orchestration/navigation.service";

import {Option} from "../option";
import {NavigationParams} from "../../../orchestration/navigation-params";

@Component({
    selector: "woa-options-page",
    templateUrl: "options-page.component.html",
    providers: [{provide: Page, useExisting: OptionsPageComponent}]
})
export class OptionsPageComponent extends Page {
    title: string;
    translationParams: any;
    options: Option[];
    showNone: boolean;

    constructor(navigationParams: NavigationParams,
                private navigationService: NavigationService) {
        super();
        this.title = navigationParams.get("title");
        this.translationParams = navigationParams.get("translationParams");
        this.options = navigationParams.get("options");
        this.showNone = navigationParams.get("showNone");
        if (this.showNone == undefined) {
            this.showNone = true;
        }
    }

    async selectOption(option: Option): Promise<any> {
        return this.navigationService.dismissPage(this, option);
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/selection-field/options-page/options-page.component.ts